import { FrameName } from "../config";
import GrasslandTerrainTileEntity from "./GrasslandTerrainTileEntity";

class Grassland1TerrainTileEntity extends GrasslandTerrainTileEntity {
	public static readonly frameName = FrameName.GRASSLAND1;
}

export default Grassland1TerrainTileEntity;
